import { render, staticRenderFns } from "./sectionAditionalInfos.vue?vue&type=template&id=1c0297e0&"
import script from "./sectionAditionalInfos.vue?vue&type=script&lang=js&"
export * from "./sectionAditionalInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports